module.exports = __webpack_public_path__ + "assets/img/no-info.752f1f01.png";